/* eslint-disable function-paren-newline */
import { RouteConfig } from 'vue-router'

import emailConfirmationGuard from '@/router/guards/emailConfirmation'
import loginGuard from '@/router/guards/login'
import oneTimeLoginGuard from '@/router/guards/oneTimeLogin'
import store from '@/store'

const Login = () =>
  import(/* webpackChunkName: "login" */ '@/views/login/CSLogin.vue')

const OAuthLogin = () =>
  import(/* webpackChunkName: "OAuthlogin" */ '@/views/oAuthLogin/CSOAuthLogin.vue')

const OAuthAuthorize = () =>
  import(/* webpackChunkName: "OAuthAuthorize" */ '@/views/oAuthAuthorize/CSOAuthAuthorize.vue')

const ForgotPassword = () =>
  import(
    /* webpackChunkName: "forgotPassword" */
    '@/views/password/ForgotPassword.vue'
  )

const ResetPassword = () =>
  import(
    /* webpackChunkName: "resetPassword" */
    '@/views/password/ResetPassword.vue'
  )

const CreatePassword = () =>
  import(
    /* webpackChunkName: "createPassword" */
    '@/views/password/CreatePassword.vue'
  )

const getEmailAsProp = ({ query: { email } }) => ({ email })

const userRoutes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: loginGuard,
    meta: {
      layout: 'wide',
      gtm: 'login',
      translateKey: 'PAGETITLE_GERMAN_LOGIN',
    },
  },
  {
    path: '/oauth',
    name: 'oauth',
    component: OAuthLogin,
    meta: {
      layout: 'wide',
      gtm: 'oAuthLogin',
      translateKey: 'PAGETITLE_GERMAN_LOGIN',
    },
  },
  {
    path: '/authorize',
    name: 'authorize',
    component: OAuthAuthorize,
    meta: {
      layout: 'wide',
      gtm: 'oAuthAuthorize',
      translateKey: 'PAGETITLE_GERMAN_LOGIN',
    },
  },

  {
    path: '/logout',
    name: 'logout',
    beforeEnter: (to, from, next) => {
      store.commit('auth/deleteAuth')
      next({ name: 'login' })
    },
  },

  {
    path: '/passwort-aendern/:token?',
    name: 'reset-password',
    component: ResetPassword,
    props: true,
    meta: {
      layout: 'main',
      gtm: 'reset password',
      translateKey: 'PAGETITLE_GERMAN_RESETPASSWORD',
    },
  },

  {
    path: '/passwort-vergessen',
    name: 'forgot-password',
    component: ForgotPassword,
    props: getEmailAsProp,
    meta: {
      layout: 'main',
      gtm: 'forgot password',
      translateKey: 'PAGETITLE_GERMAN_FORGOTPASSWORD',
    },
  },

  {
    path: '/neues-passwort',
    name: 'create-password',
    component: CreatePassword,
    props: getEmailAsProp,
    meta: {
      layout: 'main',
      gtm: 'create password',
      translateKey: 'CREATE_NEW_PASSWORD',
    },
  },

  {
    path: '/confirmation/:token',
    name: 'email-confirmation',
    beforeEnter: emailConfirmationGuard,
    meta: {
      gtm: 'registration - email confirmation page',
      translateKey: 'PAGETITLE_GERMAN_EMAILCONFIRMATION',
    },
  },

  {
    path: '/one-time-login/:token',
    name: 'one-time-login',
    beforeEnter: oneTimeLoginGuard,
    meta: {
      gtm: 'one time login page',
      title: '',
    },
  },
]

export default userRoutes
